import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterOpcoesFiltro() {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/relatorios/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(codigo, filtro) {
        let url = `${api}/credenciados/gerentes/relatorios/${codigo}?unidade=${filtro.unidade ? filtro.unidade : ''
            }&gestor=${filtro.gestor ? filtro.gestor : ''}&dataInicioDe=${filtro.dataInicioDe ? filtro.dataInicioDe : ''
            }&dataInicioAte=${filtro.dataInicioAte ? filtro.dataInicioAte : ''
            }&dataTerminoDe=${filtro.dataTerminoDe ? filtro.dataTerminoDe : ''
            }&dataTerminoAte=${filtro.dataTerminoAte ? filtro.dataTerminoAte : ''
            }&situacao=${filtro.situacao != -1 ? filtro.situacao : ''}&status=${filtro.status != -1 ? filtro.status : ''
            }&dataPrevisaoDe=${filtro.dataPrevisaoDe ? filtro.dataPrevisaoDe : ''
            }&dataPrevisaoAte=${filtro.dataPrevisaoAte ? filtro.dataPrevisaoAte : ''
            }`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
